export default "__VITE_ASSET__CGARjTIw__"